<div class="login-container">
	<mat-card
		class="mat-card-no-padding mobile-spacing reset-password-card"
		[ngClass]="{ 'background-blue': showRegistrationComplete }"
	>
		<div class="main-content">
			<div class="row-center banner"></div>

			<div class="login-card-content">
				<mat-horizontal-stepper linear #stepper>
					<!-- Step 1: Complete Registration -->
					<mat-step>
						<app-complete-registration
							[email]="this.registerUserData.email"
							[firstName]="this.registerUserData.firstName"
							[lastName]="this.registerUserData.lastName"
							[assignedRoleName]="this.registerUserData.assignedRoleName"
							[assignedCompanyName]="this.registerUserData.assignedCompanyName"
							[mobilePhoneNumber]="this.registerUserData.mobilePhoneNumber"
							[token]="this.registerUserData.token"
							[userId]="this.registerUserData.userId"
							[securityQuestion]="this.registerUserData.securityQuestion"
							[securityAnswer]="this.registerUserData.securityAnswer"
							(updateStepperDetails)="onUpdateStepperDetails($event)"
							(registerUserData)="onUpdateRegisterUserData($event)"
							(showMobileVerificationScreen)="onShowMobileVerificationScreen($event)"
						>
						</app-complete-registration>
					</mat-step>

					<!-- Step 2: Verify Mobile Number -->
					@if (this.showVerifyMobilePhoneNumber) {
						<mat-step>
							<app-verify-mobile-number
								[userId]="this.userId"
								[mobilePhoneNumber]="this.registerUserData.mobilePhoneNumber"
								(updateStepperDetails)="onUpdateStepperDetails($event)"
							>
							</app-verify-mobile-number>
						</mat-step>
					}

					<!-- Step 3: Create Password -->
					<mat-step>
						<app-create-password
							(userPassword)="onUserPasswordValid($event)"
							(updateStepperDetails)="onUpdateStepperDetails($event)"
							[verifiedPhoneNumber]="this.showVerifyMobilePhoneNumber"
						>
						</app-create-password>
					</mat-step>

					<!-- Step 4: Security Question (lazy: Safari fails to paint pre-mounted off-screen step content) -->
					<mat-step>
						<ng-template matStepContent>
							<app-security-question
								(securityQuestion)="onSecurityQuestionValid($event)"
								(securityAnswer)="onSecurityAnswerValid($event)"
								(updateStepperDetails)="onUpdateStepperDetails($event)"
								(submitRegisterUserData)="submitRegisterUserData()"
							>
							</app-security-question>
						</ng-template>
					</mat-step>

					<!-- Step 5: Registration Complete -->
					<mat-step>
						<div [ngClass]="{ 'background-blue': showRegistrationComplete }">
							<app-register-user-confirmation
								[registerUserRequestStatusEvents]="registerUserRequestStatusEvents"
								(submitRegisterUserData)="submitRegisterUserData()"
							>
							</app-register-user-confirmation>
						</div>
					</mat-step>
				</mat-horizontal-stepper>
			</div>
		</div>

		<div class="column-flex-end progress-bar-bottom">
			<div class="progress-bar-container">
				<div class="progress-bar-content">
					<p class="progress-bar-title">Step {{ this.initialStep }}</p>
					<mat-progress-bar mode="determinate" value="{{ this.progressBarValue }}"></mat-progress-bar>
				</div>
			</div>
		</div>
	</mat-card>
</div>
